import React from 'react';

export default function Footer({ name }) {
    return (
        <footer className="bg-slate-900 border-t border-slate-800 py-12 text-center text-slate-400">
            <p>&copy; {new Date().getFullYear()} {name}. All rights reserved.</p>
        </footer>
    );
}
